import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, MessageSquareIcon, SmartphoneIcon, ScaleIcon, ClipboardCheckIcon, CheckIcon, XIcon } from 'lucide-react';
const features = [{
  icon: BookOpenIcon,
  title: 'La Biología del Portazo',
  desc: 'Entiende exactamente qué pasa en su cerebro para dejar de tomarte sus ataques como algo personal.'
}, {
  icon: MessageSquareIcon,
  title: 'Guiones de Emergencia',
  desc: 'Frases exactas para decir cuando te contesta mal, no quiere soltar el celular o ignora sus responsabilidades.'
}, {
  icon: SmartphoneIcon,
  title: 'Protocolo WhatsApp',
  desc: 'Cómo escribirle para que te responda y no te deje “en visto” o te bloquee emocionalmente.'
}, {
  icon: ScaleIcon,
  title: 'La Matriz de Negociación',
  desc: 'Cómo intercambiar privilegios por responsabilidades de forma justa y sin discusiones.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Checklist de Auditoría de Reacción',
  desc: 'El paso a paso para que vos no pierdas los estribos antes de empezar.'
}];
const forWho = ['Padres y madres de 40 a 55 años con hijos entre 12 y 18 años.', 'Padres que sienten que han perdido el control y la conexión con sus hijos.', 'Familias donde el clima diario es de tensión, gritos o silencios incómodos.', 'Adultos que buscan soluciones prácticas y rápidas, no teorías interminables.'];
const notForWho = ['Personas que buscan métodos de disciplina física o autoritarismo rígido.', 'Padres que no están dispuestos a cambiar su propia forma de reaccionar.', 'Casos que requieren intervención psiquiátrica o clínica especializada.'];
export function FeaturesSection() {
  return <section className="py-24 bg-brand-cream-light px-4" data-id="element-32">
      <div className="max-w-5xl mx-auto" data-id="element-33">
        {/* What's inside */}
        <div className="mb-24" data-id="element-34">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl text-brand-navy font-bold mb-12 text-center" data-id="element-35">
            Lo que encontrarás dentro
          </motion.h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-36">
            {features.map((feature, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="bg-white p-8 rounded-2xl shadow-soft border-l-4 border-brand-navy hover:border-brand-orange transition-colors duration-300" data-id="element-37">
                <feature.icon className="w-10 h-10 text-brand-orange mb-6" data-id="element-38" />
                <h3 className="text-xl font-bold text-brand-navy mb-3" data-id="element-39">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-40">{feature.desc}</p>
              </motion.div>)}
          </div>
        </div>

        {/* Who is it for / not for */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-41">
          {/* Is For */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 md:p-10 rounded-3xl shadow-soft border border-green-100" data-id="element-42">
            <h3 className="text-2xl font-bold text-brand-navy mb-8 flex items-center gap-3" data-id="element-43">
              Esto es para ti si…
            </h3>
            <ul className="space-y-5" data-id="element-44">
              {forWho.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-45">
                  <div className="mt-1 bg-green-100 p-1 rounded-full flex-shrink-0" data-id="element-46">
                    <CheckIcon className="w-4 h-4 text-green-600" data-id="element-47" />
                  </div>
                  <span className="text-gray-700" data-id="element-48">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-brand-cream p-8 md:p-10 rounded-3xl border border-red-100" data-id="element-49">
            <h3 className="text-2xl font-bold text-brand-navy mb-8 flex items-center gap-3" data-id="element-50">
              No es para ti si…
            </h3>
            <ul className="space-y-5" data-id="element-51">
              {notForWho.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-52">
                  <div className="mt-1 bg-red-100 p-1 rounded-full flex-shrink-0" data-id="element-53">
                    <XIcon className="w-4 h-4 text-red-600" data-id="element-54" />
                  </div>
                  <span className="text-gray-700" data-id="element-55">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}